import { PricePoint } from '../../buyers/PricePoint'
import { Player } from '../Player'
import QuestionSingle from '../Questions/QuestionSingleContainer'
import { useOpeningVideo } from '../../../hooks/useOpeningVideo'
import { useIntl } from 'react-intl'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'

import styles from './OpeningVideo.module.scss'

const OpeningVideo = () => {
  const intl = useIntl()
  const { audience, videoType, videoId } = useOpeningVideo()
  const topic = audience === 'buyers' ? CUSTOMER_MESSAGES.BUYER_VIDEO_EMAIL : CUSTOMER_MESSAGES.VIDEO_EMAIL

  return (
    <div className={styles.container} data-qa='videoContainer'>
      <Player
        videoId={videoId}
        videoType={videoType}
        className={videoType === 'bombbomb' ? styles.bombBombVideoPlayer : null}
      />
      <div className={styles.footer}>
        <div className={styles.questionContainer}>
          <QuestionSingle
            placeholder={intl.formatMessage(topic.message)}
            questionTopic={topic.topic}
            questionTopicKey={topic.topicKey}
          />
        </div>
        {audience === 'buyers' && <PricePoint hideCardBg={true} />}
      </div>
    </div>
  )
}

export default OpeningVideo
